/* eslint-disable max-len */
import {
  Component,
  Host,
  Event,
  EventEmitter,
  h,
  Prop,
  State,
  Method,
  Watch,
  Element,
} from '@stencil/core';
import { versionComponent } from '../../global/inject-dependencies';

/**
 * @slot default - Content which is supposed to be rendered above the title
 */

@Component({
  tag: 'ui-tab',
  styleUrl: 'ui-tab.scss',
  shadow: true,
})
export class UiTab {
  @Element() el: HTMLElement;

  /**
   * Tab identifier
   */
  @Prop({ reflect: true }) tabId: number;

  /**
   * Tab title
   */
  @Prop() tabTitle: string;

  /**
   * When set to true, the tab's appearance is set to display an open tab, otherwise it will look as if
   * it was not selected. The default value is *false*.
   */
  @Prop({ reflect: true, mutable: true }) active = false;

  @State() tabActive = false;

  /**
   * Event triggered when the component is selected
   */
  @Event({ eventName: 'tabClicked' }) tabClickEvent: EventEmitter;

  componentWillLoad() {
    this.tabActive = this.active;
  }

  /**
   * Changes the tab's appearance to one of a tab that is being used
   */
  @Method()
  async activate() {
    this.active = true;
  }

  /**
   * Changes the tab's appearance to one of a tab that is deactivated
   */
  @Method()
  async deactivate() {
    this.active = false;
  }

  @Watch('active')
  updateTabActive() {
    this.tabActive = this.active;
  }

  clickOnTab() {
    if (!this.tabActive) {
      this.tabClickEvent.emit({ tabId: this.tabId });
    }
  }

  render() {
    return (
      <Host
        class={{
          active: this.tabActive,
        }}
        onClick={() => this.clickOnTab()}
        aria-controls={this.tabId}
      >
        <slot></slot>
        <a>{this.tabTitle}</a>
      </Host>
    );
  }
}

versionComponent(UiTab);
